import { render, staticRenderFns } from "./HomeGuide.vue?vue&type=template&id=087447d3&scoped=true&"
import script from "./HomeGuide.vue?vue&type=script&lang=js&"
export * from "./HomeGuide.vue?vue&type=script&lang=js&"
import style0 from "./HomeGuide.vue?vue&type=style&index=0&id=087447d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087447d3",
  null
  
)

export default component.exports